'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _lodash = require('lodash');

var _MyPropertiesBlock = require('./MyPropertiesBlock.scss');var styles = _interopRequireWildcard(_MyPropertiesBlock);
var _components = require('../../../../components');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Styles

var MyPropertiesBlock = function MyPropertiesBlock(props) {
  var propertiesData = (0, _lodash.get)(props.userProperties, 'data.meta.user_properties', {});var
  allowed = propertiesData.allowed,allowedUntil = propertiesData.allowed_until;

  var today = (0, _moment2.default)();
  var allowedUntilDate = (0, _moment2.default)(allowedUntil);
  var untilDate = '-';

  if (allowedUntil) {
    if (today < allowedUntilDate) {
      untilDate = allowedUntilDate.utc().format('DD/MM/YYYY');
    }
  }

  var daysDiff = allowedUntilDate.diff(today, 'days') > 0 ? allowedUntilDate.diff(today, 'days') : '';

  return (
    _react2.default.createElement('div', { className: styles.flexPosition },
      _react2.default.createElement('div', { className: styles.userData },
        _react2.default.createElement('div', { className: styles.packageName }, props.translate('managePage', 'israelProperties')),
        _react2.default.createElement('div', { className: styles.validUntilWrapper },
          _react2.default.createElement('span', { className: styles.topBlockText },
            props.translate('managePage', 'validUntil') + ': ',
            _react2.default.createElement('span', null,
              untilDate)),


          _react2.default.createElement('div', {
              className: styles.days }, ' ' +

            daysDiff + ' ' + props.translate('managePage', 'daysLeft')))),



      _react2.default.createElement('div', { className: styles.userData },
        _react2.default.createElement('div', { className: styles.remainingProps },
          _react2.default.createElement('span', { className: styles.topBlockText },
            props.translate('managePage', 'remainingProperties') + ':  '),

          _react2.default.createElement('span', { className: styles.boldText }, '\xA0' + (
            props.metaStaff && props.metaStaff.canAddProperties) + '\n            ' +
            props.translate('managePage', 'of') + '\n            ' +
            allowed))),




      _react2.default.createElement(_components.PackagePromotion, {
        translate: props.translate('managePage'),
        packageName: 'highlight',
        iconName: 'promoted',
        defaultPromoted: props.metaStaff && props.metaStaff.canAddColorPromotions,
        promotions: (0, _lodash.get)(props, 'userProperties.data.meta.user_properties.promotion', {}),
        packageStyle: styles.packagePromotion,
        labelStyle: styles.packagePromotionLabel,
        counter: styles.counter,
        isRtl: props.isRtl }),

      _react2.default.createElement(_components.PackagePromotion, {
        translate: props.translate('managePage'),
        packageName: 'top_promotion',
        iconName: 'top-promotion',
        defaultPromoted: props.metaStaff && props.metaStaff.canAddTopPromotions,
        promotions: (0, _lodash.get)(props, 'userProperties.data.meta.user_properties.top_promotion', {}),
        packageStyle: styles.packagePromotion,
        labelStyle: styles.packagePromotionLabel,
        counter: styles.counter,
        isRtl: props.isRtl }),

      _react2.default.createElement('button', {
          className: styles.updateBtn,
          onClick: props.openFormModal },

        _react2.default.createElement('span', { className: 'icon icon-rotate' },
          _react2.default.createElement('span', { className: 'path1' }),
          _react2.default.createElement('span', { className: 'path2' }),
          _react2.default.createElement('span', { className: 'path3' }),
          _react2.default.createElement('span', { className: 'path4' }),
          _react2.default.createElement('span', { className: 'path5' })),

        _react2.default.createElement('span', { className: styles.updateBtnText }, props.translate('managePage', 'packageUpdate')))));



};
MyPropertiesBlock.propTypes = {
  translate: _propTypes2.default.func,
  openFormModal: _propTypes2.default.func,
  userProperties: _propTypes2.default.object,
  metaStaff: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool };exports.default =


MyPropertiesBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/MyProperiesBlock/MyPropertiesBlock.js
// module id = 1251
// module chunks = 0